import { ProductComparisonStorage } from './product-comparison-storage';
import { QBus } from '@otto-ec/global-resources/event-q-bus';

export type ProductComparisonApi = {
    /**
 *
 *
 *
 *
 *
 */
    addToList: (contextId: string, variationId: string) => Promise<string | null>;

    /**
 *
 *
 *
 *
 *
 */
    removeFromList: (contextId: string, variationId: string) => Promise<string | null>;

    /**
 *
 *
 *
 *
 */
    removeList: (contextId: string) => Promise<string | null>;

    /**
 *
 *
 *
 *
 */
    getList: (contextId: string) => Promise<string[] | null>;

    /**
 *
 *
 *
 */
    getLists: () => Promise<string[] | null>;

    /**
 *
 *
 *
 *
 *
 */
    isOnList: (contextId: string, variationId: string) => Promise<boolean>;

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    getLinkForList: (contextId: string) => Promise<string | null>;
};

export function isProductComparisonApi(object: unknown): object is ProductComparisonApi {
    return (
        object !== null &&
        typeof object === 'object' &&
        ['addToList', 'removeFromList', 'removeList', 'getList', 'getLists', 'isOnList', 'getLinkForList'].every(key => key in object)
    );
}

export const createProductComparison = (storage: ProductComparisonStorage = new ProductComparisonStorage()): ProductComparisonApi => {
    return {
        addToList: async (contextId?: unknown, variationId?: unknown): Promise<string | null> => {
            if (typeof contextId !== 'string') {
                throw illegalParameterError('contextId', contextId);
            }

            if (typeof variationId !== 'string') {
                throw illegalParameterError('variationId', variationId);
            }

            const list = storage.retrieveStoredListForContextId(contextId);

            if (list) {
                /*                                                                                                                   */
                storage.storeListForContextId(contextId, [...list.filter(el => el !== variationId), variationId]);
                return !list.includes(variationId) ? variationId : null;
            } else {
                storage.storeListForContextId(contextId, [variationId]);
                return variationId;
            }
        },

        removeFromList: async (contextId?: unknown, variationId?: unknown): Promise<string | null> => {
            if (typeof contextId !== 'string') {
                throw illegalParameterError('contextId', contextId);
            }

            if (typeof variationId !== 'string') {
                throw illegalParameterError('variationId', variationId);
            }

            const list = storage.retrieveStoredListForContextId(contextId);

            if (list === null || !list.includes(variationId)) {
                return null;
            } else if (list.length === 1) {
                /*                                                     */
                storage.removeStoredListForContextId(contextId);
                return variationId;
            } else {
                storage.storeListForContextId(
                    contextId,
                    list.filter(el => el !== variationId)
                );

                return variationId;
            }
        },

        removeList: async (contextId?: unknown): Promise<string | null> => {
            if (typeof contextId !== 'string') {
                throw illegalParameterError('contextId', contextId);
            }

            return storage.removeStoredListForContextId(contextId);
        },

        getList: async (contextId?: unknown): Promise<string[] | null> => {
            if (typeof contextId !== 'string') {
                throw illegalParameterError('contextId', contextId);
            }

            return storage.retrieveStoredListForContextId(contextId);
        },

        getLists: async (): Promise<string[] | null> => {
            const storedListsByContextId = storage.retrieveStoredListsByContextId();

            return storedListsByContextId === null ? null : Object.keys(storedListsByContextId);
        },
        isOnList: async (contextId?: unknown, variationId?: unknown): Promise<boolean> => {
            if (typeof contextId !== 'string') {
                throw illegalParameterError('contextId', contextId);
            }

            if (typeof variationId !== 'string') {
                throw illegalParameterError('variationId', variationId);
            }

            const list = storage.retrieveStoredListForContextId(contextId);
            return list !== null && list.includes(variationId);
        },

        getLinkForList: async (contextId?: unknown): Promise<string | null> => {
            if (typeof contextId !== 'string') {
                throw illegalParameterError('contextId', contextId);
            }

            const list = storage.retrieveStoredListForContextId(contextId);

            return list === null ? null : `/vergleich/?variationIds=${list.join(',')}`;
        },
    };
};

const illegalParameterError = (name: string, value: unknown): Error => {
    return new Error(`Illegal parameter '${name}'; value: ${JSON.stringify(value)}`);
};

export const productComparisonLoadedTopic = 'ft5.productComparison.loaded';

export const emitProductComparisonLoadedEvent = (bus: QBus): void => {
    bus.emitRetain(productComparisonLoadedTopic, createProductComparison());
};
